import 'rxjs/add/operator/takeUntil';
import { SnackbarService, SnackbarType } from './snackbar.service';
import { Subject } from 'rxjs/Subject';
var SnackbarComponent = (function () {
    function SnackbarComponent(snackbarService) {
        this.snackbarService = snackbarService;
        this.snackbarDisplayState = 'hidden';
        this.snackbarOptions = {
            type: SnackbarType.INFORMATION,
            message: '',
            visible: false,
            duration: -1,
            dismissible: false,
            color: '#000000',
            icon: 'information',
        };
        this.ngUnsubscribe = new Subject();
    }
    SnackbarComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.snackbarService.snackbarOptionsObservable.takeUntil(this.ngUnsubscribe).subscribe(function (value) {
            if (value.visible) {
                if (_this.snackbarOptions.visible) {
                    _this.snackbarDisplayState = 'hidden';
                    clearTimeout(_this.timeout);
                    setTimeout(function () {
                        _this.snackbarDisplayState = 'shown';
                    }, 250);
                }
                else {
                    _this.snackbarDisplayState = 'shown';
                }
                _this.snackbarOptions = value;
                if (_this.snackbarOptions.duration > 0) {
                    _this.timeout = setTimeout(function () {
                        _this.snackbarService.dismiss();
                    }, _this.snackbarOptions.duration);
                }
            }
            else {
                _this.snackbarDisplayState = 'hidden';
            }
        });
    };
    SnackbarComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SnackbarComponent.prototype.dismiss = function () {
        clearTimeout(this.timeout);
        this.snackbarService.dismiss();
    };
    return SnackbarComponent;
}());
export { SnackbarComponent };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/theme/components/snackbar/snackbar.component.ts.pre-build-optimizer.js